import { Row, Col } from "../../App.styles";

const Sticker = ({ useQuery }) => {
  const { fullscreen, overlay_thumb, txt } = useQuery();

  return (
    <>
      <Row>
        <Col>
          <p>
            Sticker: <img src={overlay_thumb} alt={txt} />
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Style: {fullscreen ? "fullscreen" : "floating"}</p>
        </Col>
      </Row>
    </>
  );
};

export default Sticker;
